<template minapp='mpx' xlang='wxml'>
    <view role="popup">
      <es-overlay
      wx:if="{{overlay}}"
      show="{{value || show}}"
      bind:click="onClickOverlay"
      position="fade"
      custom-style="{{ overlayStyle ? overlayStyle : customStyle}}"
      />

      <es-transition
      custom-style="{{customStyle}}"
      custom-class="{{classNames}} custom-class"
      show="{{value || show}}"
      name="{{position}}"
      bind:leave='transitionEnd'
      >
        <slot></slot>
        <es-icon 
        wx:if="{{closeable}}" 
        class="es-popup__close" 
        name='close' 
        size='24' 
        bind:click='onClickOverlay'
        />
      </es-transition>
    </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      value: Boolean,
      show: Boolean,
      overlay: {
        type: Boolean,
        value: true
      },

      closeOnClickOverlay: {
        type: Boolean,
        value: true
      },

      position: {
        type: String,
        value: 'center'
      },
      closeable: {
        type: Boolean,
        value: false
      },
      customStyle: null,
      overlayStyle: null
    },

    computed: {
      classNames() {
        return this.$classnames(this.className, 'es-popup', 'es-popup--' + this.position).join(' ')
      }
    },

    watch: {
      value(val) {
        if (val === true) {
          this.emitShow()
        }
      },
      show(val) {
        if (val === true) {
          this.emitShow()
        }
      }
    },

    methods: {
      onClickOverlay() {
        if (this.closeOnClickOverlay) {
          this.$trigger('overlay-click')
        }
        this.$trigger('close')
        this.$trigger('input', { value: false })
      },
      transitionEnd() {
        this.$trigger('hide')
      },
      emitShow() {
         this.$trigger('show')
      }
    },

    mounted() {
      if (__mpx_mode__ == 'web') {
        document.body.appendChild(this.$el)
      }
    },
    
    destroyed() {
      if (__mpx_mode__ == 'web') {
        if (document.body.contains(this.$el)) {
          document.body.removeChild(this.$el)
        }
      }
    }
  })
</script>

<style lang='stylus' src='./style.styl'></style>
<script  type='application/json' lang='json'>
{
 "component": true,
 "usingComponents": {
    "es-overlay": "../overlay/index",
    "es-transition": "../transition/index",
    "es-icon": '../icon'

  }
}
</script>

